<script>

import data from "./emojis-data.json";

export default {
  props: {
    show_arrow: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    categories() {
      return Object.keys(data);
    },

    category_emojis: () => (category) => {
      return Object.values(data[category]);
    },
  },
  methods: {
    handleEmojiClick(e, emoji) {
      e.preventDefault();
      this.$emit("emoji_click", emoji);
      document.querySelector('.inputs_mensaje_chat').value += emoji
    },
  },
};
</script>

<template>
  <div class="emoji_picker">
    <div class="picker_container">
      <div
        class="category"
        v-for="category in categories"
        :key="`category_${category}`"
      >
        <span>{{ category }}</span>
        <div class="emojis_container">
          <button
            @click="handleEmojiClick($event, emoji)"
            v-for="(emoji, index) in category_emojis(category)"
            :key="`emoji_${index}`"
          >
            {{ emoji }}
          </button>
        </div>
      </div>
    </div>
    <div class="bottom_arrow" v-if="show_arrow"></div>
  </div>
</template>